
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';

export default function Home() {
  const benefits = [
    {
      icon: 'ri-bar-chart-line',
      title: 'Unified Analytics Hub',
      description: 'All your data in one place.'
    },
    {
      icon: 'ri-flashlight-line',
      title: 'AI-Powered Predictions',
      description: 'Forecast and plan with confidence.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Secure & Scalable',
      description: 'Enterprise-grade compliance.'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-950 text-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat px-4"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url('https://static.readdy.ai/image/0e1febb5c446844011e1a9fd921d94f7/be7d6f0cb738dc072c02b9922fbfc406.jfif')`
        }}
      >
        <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center w-full">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4 bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent leading-tight">
              Transform Data into Clarity. Decisions into Impact.
            </h1>
            <p className="text-lg sm:text-xl md:text-xl text-gray-300 mb-6 leading-relaxed px-4">
              Prismatics AI is an intelligent data analysis and visualization platform that helps enterprises unlock insights, predict outcomes, and automate workflows — all from their existing data. With powerful yet simple visualizations, teams can instantly understand trends and opportunities without technical barriers.
            </p>
            <div className="flex justify-center w-full">
              <div className="relative">
                <div className="absolute inset-0 bg-gray-900/30 rounded-xl transform scale-110"></div>
                <Link to="/schedule-demo">
                  <Button variant="primary" size="lg" className="relative whitespace-nowrap">
                    <i className="ri-calendar-line mr-2"></i>
                    Schedule Demo
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-20 bg-gray-900">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {benefits.map((benefit, index) => (
              <div key={index} className="text-center p-8 bg-gray-800 rounded-2xl border border-gray-700 hover:border-blue-5000 transition-all duration-300">
                <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-r from-blue-600 to-purple-600 rounded-full mx-auto mb-6">
                  <i className={`${benefit.icon} text-2xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold mb-4">{benefit.title}</h3>
                <p className="text-gray-400">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-blue-900 to-purple-900">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Ready to Transform Your Data?
          </h2>
          <p className="text-xl text-gray-300 mb-8">
            Join forward-thinking enterprises who trust Prismatics AI to unlock their data potential.
          </p>
         <div className="flex justify-center mt-6">
  <Link to="/schedule-demo">
    <Button variant="secondary" size="lg">
      Schedule Your Demo Today
    </Button>
  </Link>
</div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
